import { createContext, useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom"
import PropTypes from "prop-types";
import { DataContext } from "../DataProviders/DataProvider";

// Create the context
const UploadContext = createContext();

// Create the provider
export const UploadProvider = ({ children }) => {


  const getPageName = (step) => {
    switch (step) {
      case 0:
        return "Email Accounts";
      case 1:
        return "Connected Apps";
      case 2:
        return "Checkout";
      default:
        return "";
    }
  };

  const { orderId, isTimezoneAvailabe } = useContext(DataContext);
  const location = useLocation();
  const initialStep = location.state?.initialStep ?? 0; // Default to 0 if no state is provided
  const [activeStep, setActiveStep] = useState(initialStep);
  const [pageName, setPageName] = useState(getPageName(initialStep));


  const [file, setFile] = useState(null);
  const [latestOrderId, setLatestOrderId] = useState(0);

  const uploadFile = (newFile) => {
    setFile(newFile);
  };

  // Function to determine if the user can proceed to the specified step
  const canProceedToStep = (step, val) => {
    const isOrderIdValid =
      orderId !== null && orderId !== undefined && orderId.trim() !== "";

    // Check if val is undefined or null, then use isTimezoneAvailable
    if (val === undefined || val === null) {
      val = isTimezoneAvailabe;
    }
    switch (step) {
      case 0:
        return true;
      case 1:
        return isOrderIdValid;
      case 2:
        return val;
      default:
        return false;
    }
  };


  // Function to handle next button click
  const handleNext = (val) => {
    const nextStep = activeStep + 1;
    if (canProceedToStep(nextStep, val)) {
      setActiveStep(nextStep);
      setPageName(getPageName(nextStep));
      window.scrollTo(0, 0); // Scroll to top of the page after clicking on next
    }
  };

  // Function to handle back button click
  const handleBack = () => {
    const prevStep = activeStep - 1;
    if (prevStep >= 0) {
      setActiveStep(prevStep);
      setPageName(getPageName(prevStep));
      window.scrollTo(0, 0); // Scroll to top of the page after clicking on back
    }
  };


  // Function to handle click on step
  const handleStepClick = (step) => {
    if (canProceedToStep(step)) {
      setActiveStep(step);
      window.scrollTo(0, 0); // Scroll to top of the page after clicking on a step
      setPageName(getPageName(step));
    }
  };

  return (
    <UploadContext.Provider value={{ file, uploadFile, latestOrderId, setLatestOrderId, activeStep, handleBack, handleNext }}>
      {children}
    </UploadContext.Provider>
  );
};

UploadProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default UploadContext;
